/** Cache correlation only; the server independently authenticates every request. */
export function readAdminPermissionSession(): { userId: string; sessionId: string } | null {
  const token = typeof localStorage === 'undefined' ? null : localStorage.getItem('token');
  if (!token) return null;
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(part.padEnd(Math.ceil(part.length / 4) * 4, '=')));
    if (payload.type !== 'admin' || !payload.sub || !payload.sid) return null;
    if (typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now()) return null;
    return { userId: String(payload.sub), sessionId: String(payload.sid) };
  } catch {
    // Opaque/legacy tokens may fetch fresh permissions but cannot reuse a session cache.
    return null;
  }
}

export function isCurrentPermissionCache(data: { userId: string; sessionId?: string }): boolean {
  const session = readAdminPermissionSession();
  return Boolean(
    session && session.userId === String(data.userId) && session.sessionId === data.sessionId,
  );
}
